import React from 'react';
import styles from './Footer.module.scss';

function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerContent}>
        © Copyright Open Parachute {(new Date().getFullYear()) || '2022'}
      </div>
    </footer>
  );
}

export default Footer;
